import { hasValue } from '../utils';

var checkAllPositive = function (sourceValues, fieldName) { return sourceValues.every(function (ref) {
        var valueFields = ref.valueFields;

        return !hasValue(valueFields[fieldName]) || valueFields[fieldName] > 0;
        }); };

export default checkAllPositive;
